export default {
  methods: {
    pushOrGo(opts) {
      // sometimes router will push to the same route, and when it does, it will need to refresh
      // the page. Eg: Voiding a member from Member Details will need to refresh Member Details
      // to get the latest (empty) coverage payload. When you push the to same route you're on, the
      // created event never fires. We'll use the onAbort callback to call go() after the push
      // because according to the docs, aborted: called (navigated to the same route, or to a
      // different route before current navigation has finished) and go() https://stackoverflow.com/a/47005895
      if (opts.name && this.$route.name === opts.name) {
        // the first method will trigger if it's the same router name, but the params are different
        // eg: going from subscriber to dependent, the second method will trigger if everything
        // in the route is idential, eg: clicking voidMember on member details and pushing to
        // member details
        const goAfterPush = (opts) => { this.$router.push(opts) }
        //here router.push with a random date string in query creates a page refresh
        this.$router.push({  
          ...opts, query: { _r: Date.now() }
        }, goAfterPush, goAfterPush)
      } else {
        this.$router.push(opts)
      }
    }
  }
}
